import React, { useEffect } from 'react';
import { Menu } from '../ui/layout/Menu';
import { User } from '../@backend';
import useApi from '../hooks/useApi';
import { FooterCmp } from '../ui/layout/Footer';
import { userState } from '../store';
import { useSnapshot } from 'valtio';
import { PrizeMoney } from '../ui/PrizeMoney';
import { AiFillCheckCircle, AiFillPayCircle } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { MdEmail } from 'react-icons/md';
import { PageHeader } from '../ui/ds/PageHeader';
import { Card } from '../ui/ds/Card';

const RANK_COLORS = ['#F56723', '#8892a4', '#c0400e'];

export const Ladder = () => {
    const userSnap = useSnapshot(userState);
    const apiUrl   = process.env.REACT_APP_API_URL ?? 'http://localhost:3000';
    const [users, setUsers] = React.useState<User[]>([]);
    const { backend } = useApi();

    const loadLadder = () => {
        backend.ladder.ladderControllerGetAllUsersInLadder().then((resUsers: User[]) => {
            setUsers(resUsers);
        });
    };

    useEffect(() => {
        if (userSnap.isLoggedIn) {
            loadLadder();
        }
    }, [userSnap.isLoggedIn]);

    const payEntryFee = (userId: string) => {
        backend.user.userControllerPayEntryFee(userId).then(() => {
            alert('Zaplaceno');
            loadLadder();
        });
    };

    const sendPaymentInfo = (userId: string) => {
        backend.user.userControllerSendPaymentInfo(userId).then(() => {
            alert('Platební údaje byly odeslány na email');
        });
    };

    const isAdmin = userSnap.userProfile?.role === 'Admin';

    return (
        <>
            <Menu />

            <PageHeader title="Žebříček" subtitle="Aktuální pořadí hráčů" />

            <div className="max-w-4xl mx-auto px-4 md:px-8 py-6 flex flex-col gap-6">
                {/*<PrizeMoney showRegisterButton={!userSnap.isLoggedIn} />*/}

                {userSnap.isLoggedIn ? (
                    <Card padding="none">
                        <div className="overflow-x-auto">
                            {/* Table header */}
                            <div className="flex items-center px-5 py-3 bg-bg-app border-b border-border-neutral rounded-t-content">
                                <div className="w-10 tb-label text-center">#</div>
                                <div className="flex-1 tb-label">Hráč</div>
                                <div className="w-20 tb-label text-right">Body</div>
                                {/*{isAdmin && (*/}
                                {/*    <>*/}
                                {/*        <div className="w-24 tb-label text-center">Zaplaceno</div>*/}
                                {/*        <div className="w-36 tb-label">Akce</div>*/}
                                {/*    </>*/}
                                {/*)}*/}
                            </div>

                            {/* Rows */}
                            {users.map((user, index) => {
                                const rankColor = index < 3 ? RANK_COLORS[index] : undefined;
                                const isMe = user.id === userSnap.userProfile?.id;

                                return (
                                    <div
                                        key={user.id}
                                        className={[
                                            'flex items-center px-5 py-3 border-b border-divider-row last:border-b-0 hover:bg-bg-app transition-colors',
                                            isMe ? 'bg-brand-blue/5' : '',
                                        ].join(' ')}
                                    >
                                        {/* Rank */}
                                        <div className="w-10 text-center">
                                            <span
                                                className="text-[14px] font-black font-nunito"
                                                style={{ color: rankColor ?? '#8892a4' }}
                                            >
                                                {index + 1}
                                            </span>
                                        </div>

                                        {/* Avatar + name */}
                                        <div className="flex-1 flex items-center gap-3 min-w-0">
                                            <div className="w-9 h-9 rounded-full overflow-hidden bg-border-neutral flex items-center justify-center flex-shrink-0">
                                                {user.avatar ? (
                                                    <img
                                                        src={`${apiUrl}/avatars/${user.avatar}`}
                                                        alt="avatar"
                                                        className="w-full h-full object-cover"
                                                    />
                                                ) : (
                                                    <span className="text-[12px] font-bold text-text-muted font-nunito">
                                                        {user.firstname?.charAt(0)}{user.lastname?.charAt(0)}
                                                    </span>
                                                )}
                                            </div>
                                            {user.publicProfile ? (
                                                <Link
                                                    to={`/uzivatel/profil/${user.id}`}
                                                    className="tb-body text-brand-blue hover:underline truncate"
                                                >
                                                    {user.firstname} {user.lastname}
                                                </Link>
                                            ) : (
                                                <span className="tb-body text-text-primary truncate">
                                                    {user.firstname} {user.lastname}
                                                </span>
                                            )}
                                        </div>

                                        {/* Points */}
                                        <div className="w-20 text-right">
                                            <span className="text-[16px] font-black text-text-primary font-nunito">
                                                {user.points}
                                            </span>
                                        </div>

                                        {/* Admin actions */}
                                        {/*{isAdmin && (*/}
                                        {/*    <>*/}
                                        {/*        <div className="w-24 flex justify-center">*/}
                                        {/*            {user.entryFeePaid && (*/}
                                        {/*                <AiFillCheckCircle className="text-semantic-success text-lg" />*/}
                                        {/*            )}*/}
                                        {/*        </div>*/}
                                        {/*        <div className="w-36 flex gap-1">*/}
                                        {/*            {!user.entryFeePaid && (*/}
                                        {/*                <>*/}
                                        {/*                    <button*/}
                                        {/*                        onClick={() => payEntryFee(user.id)}*/}
                                        {/*                        className="flex items-center gap-1 bg-brand-blue text-white rounded-btn px-2 py-1 text-[12px] font-bold font-nunito hover:opacity-90 transition-opacity"*/}
                                        {/*                    >*/}
                                        {/*                        <AiFillPayCircle /> Platba*/}
                                        {/*                    </button>*/}
                                        {/*                    <button*/}
                                        {/*                        onClick={() => sendPaymentInfo(user.id)}*/}
                                        {/*                        className="flex items-center gap-1 bg-brand-blue/80 text-white rounded-btn px-2 py-1 text-[12px] font-bold font-nunito hover:opacity-90 transition-opacity"*/}
                                        {/*                    >*/}
                                        {/*                        <MdEmail /> Email*/}
                                        {/*                    </button>*/}
                                        {/*                </>*/}
                                        {/*            )}*/}
                                        {/*        </div>*/}
                                        {/*    </>*/}
                                        {/*)}*/}
                                    </div>
                                );
                            })}
                        </div>
                    </Card>
                ) : (
                    <Card className="text-center py-12">
                        <div className="text-[40px] mb-4">🏆</div>
                        <p className="tb-h2 text-text-primary mb-2">Pouze pro registrované hráče</p>
                        <p className="tb-caption">Pro zobrazení žebříčku se přihlašte a zaplaťte registrační poplatek.</p>
                    </Card>
                )}
            </div>

            <FooterCmp />
        </>
    );
};
